import React from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { Box, Typography, styled } from "@mui/material"

import { colors } from "theme"
import { ManagerType } from "types"

type Props = {
  manager: ManagerType
  children?: React.ReactNode
}

const ManagerComponent = ({ manager, children }: Props) => {
  const { t } = useTranslation()

  return (
    <Container>
      {children && <Description>{children}</Description>}
      <Content>
        <Contacts>
          <Title variant="h4">{manager.full_name}</Title>
          <Role>{t("features.payment_schedule.manager.title")}</Role>
          <Email to={`mailto:${manager.email}`}>{manager.email}</Email>
        </Contacts>
        <Phone>{manager.phone}</Phone>
      </Content>
    </Container>
  )
}

export default ManagerComponent

export const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "space-evenly",
  [theme.breakpoints.up("md")]: {
    margin: "0 auto",
    width: "700px",
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    width: "100%",
  },
}))

export const Content = styled(Box)(({ theme }) => ({
  alignItems: "flex-start",
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  justifyContent: "space-between",
  width: "50%",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}))

export const Contacts = styled(Box)(() => ({}))

const Description = styled(Typography)(({ theme }) => ({
  flex: 1,
  fontSize: "0.875rem",
  fontWeight: "300",
  [theme.breakpoints.down("md")]: {
    marginBottom: "10px",
    width: "100%",
  },
}))

const Title = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    fontSize: "1rem",
  },
}))

const Role = styled(Typography)(() => ({
  fontSize: "0.875rem",
  lineHeight: "1.6",
}))

const Email = styled(Link)(() => ({
  color: colors.brilliantAzure,
  fontSize: "0.875rem",
  fontWeight: 600,
}))

const Phone = styled(Typography)(() => ({
  backgroundColor: colors.white,
  border: `3px solid ${colors.persianGreen}`,
  borderRadius: "21px",
  color: colors.persianGreen,
  fontSize: "0.875rem",
  fontWeight: 600,
  height: "44px",
  lineHeight: "38px",
  padding: "0 20px",
  textAlign: "center",
  minWidth: "160px",
}))
